
const StripeConnectBlockData = {
  show: {
    1: {
      iconName: 'ready_to_use',
      title: 'Ready-to-use payment platform',
      bullets: [
        'Accept credit card payments online',
        'Schedule payments or process instantly',
        'Split payments automatically',
        'Use transparent accounting',
      ],
    },
    2: {
      iconName: 'embedded',
      title: 'Embedded split payments and platform commission',
      bullets: [
        'No need to process payments manually',
        'No complicated accounting',
        'Flexible payout options ',
        'Platform commission is charged automatically',
      ],
    },
    3: {
      iconName: 'security',
      title: 'Security and compliance',
      bullets: [
        'Risk-based customer verification (KYC)',
        'Anti-Money Laundering (AML) checks',
        'PCI DSS compliance',
        'Card information is absolutely secure',
      ],
    },
    4: {
      iconName: 'hight_level',
      title: 'High-level security and protection',
      bullets: [
        '99.999% average historical uptime',
        'Advanced fraud detection and prevention tools',
        'Regulatory licenses globally',
        'Bank-level security',
      ],
    },
  },
  hide: {
    1: {
      iconName: 'convenient',
      title: 'Convenient and secure payouts',
      bullets: [
        'Send funds automatically to a bank account',
        'Control payout timing',
        'View transaction history',
      ],
    },
    2: {
      iconName: 'transparent',
      title: 'Transparent pricing with no hidden fees',
      bullets: [
        'No setup fees',
        'No minimum fees',
        'Pay for successful transactions only',
      ],
    },
    3: {
      iconName: 'built_in',
      title: 'Built-in fraud prevention',
      bullets: [
        'Verifies a customer before an online card purchase',
        'Blocks suspicious transactions',
        'Notifies about any issues',
        'Runs financial accounting',
      ],
    },
    4: {
      iconName: 'user_friendly',
      title: 'User-friendly dashboards',
      bullets: [
        'Payouts dashboard',
        'Payments dashboard',
        'Payment method controls',
        'Platform reporting tools',
      ],
    },
  },
};
export default StripeConnectBlockData;
